import moment from 'moment'
import numeral from 'numeral'
import Swal from 'sweetalert2'
import React, { useState } from 'react'
import { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { ShowBusy } from '../Reducers/InicioReducer'
import { ColocarOrdenAsync, ObtenerHistorialAsync } from '../Servicios/ServiciosPublicos'

export const UltimosMovimientosRender = (params) => {
    const dispatch = useDispatch()
    const inicio = useSelector(state => state.inicio);


    //#region internalState    
    const [internalState, setInternalState] = useState({
        MonedaDetalle: params.MonedaDetalle,
        MonedaDetalleDetalle: [],
        MonedaDetallePrecioActual: 0,
        MonedaDetalleIndex: 0,
        MonedaDetalleInversion: 0,
    })
    //#endregion
    //#region useEffect
    useEffect(() => { ObtenerHistorial(); }, [])
    //#endregion
    //#region Metodos
    const ObtenerHistorial = async () => {
        dispatch(ShowBusy());
        let _historial = await ObtenerHistorialAsync({ Moneda: internalState.MonedaDetalle.Item.Clave });
        dispatch(ShowBusy(false));
        setInternalState((state) => ({
            ...state,
            MonedaDetalleDetalle: _historial.Detalle,
            MonedaDetalleInversion: _historial.Inversion,
            MonedaDetalleIndex: 0,
        }));
        if (params.CambiaHistorial) { params.CambiaHistorial(_historial); }
        console.log(_historial)
    }
    const OnClickMovimiento = async (item) => {
        console.log(item);

        let _pc = 5, _pv = 5;
        if (inicio.Books[item.Item.book]) {
            _pc = +inicio.Books[item.Item.book].CompraPorcentaje;
            _pv = +inicio.Books[item.Item.book].VentaPorcentaje;
        }

        let _porRender = (item.EsVenta ? +_pc : +_pv);
        _porRender = numeral(_porRender).format("0.00");

        if (+_pc > 0) {
            _pc = 1 - (_pc / 100);
        } else { _pc = 0.95; }
        if (+_pv > 0) {
            _pv = 1 + (_pv / 100);
        } else { _pv = 1.05; }


        // let _ni = Math.round(+item.Costo * (item.EsVenta ? +_pc : +_pv), 2);
        let _ni = +item.Costo * (item.EsVenta ? +_pc : +_pv);
        _ni = +numeral(_ni).format("0.00");
        let _amount = +numeral(+item.Importe / +_ni).format("0.00000000");
        let _tipo = item.EsVenta ? "compra" : "venta";
        let _side = item.EsVenta ? "buy" : "sell";
        let _strImporte = numeral(item.Importe).format("0,000.00");
        let _strNI = numeral(_ni).format("0,000.00");
        let _strA = numeral(_amount).format("0,000.00000000");


        let _result = await Swal.fire({
            title: ``,
            html: `¿Deseas realizar una nueva Orden de <span class="${_tipo}">${_tipo}</span> Limitada por $ ${_strImporte} (${_porRender} %) a $ ${_strNI} (${_strA})?`,
            icon: 'question',
            confirmButtonText: 'Si',
            showCancelButton: true,
            cancelButtonText: "No"
        });
        if (_result.value) {

            const { value: importe } = await Swal.fire({
                title: `Indicar el importe de ${_tipo}`,
                input: 'number',
                inputLabel: 'Importe',
                inputValue: +numeral(_strImporte).format("0.00"),
                showCancelButton: true,
                inputValidator: (value) => { if (!value) { return 'debe indicar un importe'; } }
            });

            if(importe){
                debugger
                _amount = +numeral(+importe / +_ni).format("0.00000000");
                let _order = {
                    book: item.Item.book,
                    side: _side,
                    type: "limit",
                    price: +_ni,
                    major: +_amount,
                };
                let r = await ColocarOrdenAsync(_order);
                let _result = await Swal.fire({
                    title: ``,
                    text: r.success ? "Se coloco la orden" : `${r.error.code} ${r.error.message}`,
                    icon: r.success ? 'success' : "error",
                    confirmButtonText: 'Aceptar',
                });
            }
        }
    }
    //#endregion

    return (
        <div className="tab-bitso">
            {
                internalState.MonedaDetalleDetalle.map((item, i) => {
                    const _precioActual = +item.Cantidad * +internalState.MonedaDetalle.Item.UltimoPrecio;
                    let _precioActualLetra = (+item.Importe - +_precioActual) > 0 ? "venta" : "compra";
                    if (item.EsVenta) { _precioActualLetra = _precioActualLetra === "venta" ? "compra" : "compra"; }

                    return (
                        <div index={i} className="tbl-cripto-item" onClick={() => { OnClickMovimiento(item); }}>
                            <div className="row18">
                                <div>{moment(item.Fecha).format("DD/MM/YYYY HH:mm:ss")}</div>
                                <div className={item.EsVenta ? "venta" : "compra"} >{item.EsVenta ? "Venta" : "Compra"}</div>
                                <div className={`l-${internalState.MonedaDetalle.Item.Clave}`}>{internalState.MonedaDetalle.Item.Nombre}</div>
                                <div >Actual</div>
                            </div>
                            <div className="row18">
                                <div>{numeral(item.Cantidad).format("0,000.00000000")}</div>
                                <div>{numeral(item.Importe).format("0,000.00")} MXN</div>
                                <div>{numeral(item.Costo).format("0,000.00")}</div>
                                <div className={_precioActualLetra}>{numeral(_precioActual).format("0,000.00")}</div>
                            </div>
                        </div>
                    )
                })
            }

        </div>
    )
}
